import { ChatConversationMessage, Meeting } from '../models/chat';
import { ChatMessageReceiverService } from './chat-message-receiver.service';
import { PageVisibilityService } from './page-visibility.service';
import { PushNotificationService } from './push-notification.service';
import { SyncActiveMeetingBetweenTabsService } from './sync-active-meeting-between-tabs.service';
import { PUBLIC_CHAT_ID } from './chat-conversation.service';
import { AuthServiceInterface } from './AuthServiceInterface';

export class ChatNotificationHandlerService {
    private readonly DEFAULT_ICON = '/storage/photo/mock/noimage1x1-256x256.png';

    static $inject = [
        'NativeNotificationService',
        'PushNotificationService',
        'SyncActiveMeetingBetweenTabsService',
        'ChatMessageReceiverService',
        'PageVisibilityService',
        'AuthService',
    ];

    private meetings$?: Rx.Observable<Meeting[]>;

    private log(...args: any[]) {
        console.log.apply(console, ['ChatNotificationHandlerService', ...args]);
    }

    constructor(
        private nativeNotificationService: any,
        private pushNotificationService: PushNotificationService,
        private syncActiveMeetingBetweenTabsService: SyncActiveMeetingBetweenTabsService,
        private chatMessageReceiverService: ChatMessageReceiverService,
        private pageVisibilityService: PageVisibilityService,
        private authService: AuthServiceInterface
    ) {}

    public init() {
        this.chatMessageReceiverService.onNewMessage$.subscribe(({ meetingId, message }) => {
            if (message.type !== 'message') {
                // only 'message' type should show notifications
                return;
            }

            if (meetingId === PUBLIC_CHAT_ID) {
                // ignore public chat
                return;
            }

            if (message?.owner?.id === this.authService.getUserId()) {
                this.log('onMessage - discarding - message id matches user id');
                return;
            }

            const params = this.createMessageNotificationParams(message);

            if (!params) {
                return;
            }

            this.nativeNotificationService.showNotification(params);
        });
    }

    /**
     * @param {Object} event WebSocket message:create event
     * @returns {NativeNotificationParams|undefined}
     */
    private createMessageNotificationParams(message: ChatConversationMessage) {
        const content = message.content;
        const sender = message.owner;
        const meetingId = message.meeting_id!;
        const title = sender.name + ' wrote:';

        return {
            title: title,
            options: {
                tag: ['message', sender.id].join('-'), // use tag to prevent showing multiple popups from someone who sends many messages fast
                body: content,
                renotify: true,
                icon: this.DEFAULT_ICON,
            },
            events: {
                click: this.onClickOpenUrl(['meeting', String(meetingId)]),
            },
        };
    }

    private onClickOpenUrl(pathSegments: string[], target: string = 'notification') {
        var url = [window.location.origin].concat(pathSegments).join('/');
        return function (e: any) {
            window.open(url, target);
        };
    }
}

angular.module('tradersyard').service('ChatNotificationHandlerService', ChatNotificationHandlerService);
